// Angular
import { Injectable } from '@angular/core';
import { DivisionCacheService } from '@app/services/DivisionCacheService';

// RxJS
import { of } from 'rxjs';
import { catchError, concatMap, filter, map, switchMap, tap } from 'rxjs/operators';

// ngrx
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

// App
import { FiltersState, SortAttribute, SortOrder } from '@app/store/filters/models/filters.model';
import { ResourceLoadState } from '@app/store/filters/models/resource-load.state';
import { Company, Division } from '@app/core/models/zonar-accounts.model';
// import { CoreCompanyApiService } from '@app/services/core-company-api.service';
import * as SearchFiltersActions from '@app/store/filters/actions/search-filters.actions';
import * as FilterActions from '@app/store/filters/actions/filters.actions';
import { PermissionsActionTypes } from '@app/store/permissions/actions/permissions.actions';
import * as fromFilters from '@app/store/filters/selectors/filters.selectors';
import * as fromPermissions from '@app/store/permissions/selectors/permissions.selectors';
import { selectAllPermissions } from '@app/store/permissions/selectors/permissions.selectors';
import * as fromSearchFilters from '@app/store/filters/selectors/search-filters.selector';
import { environment as env } from '@environments/environment';
import * as RouterSelectors from '@app/store/router/selectors/router.selectors';
import { SettingsApiService } from '@app/services/settings-api.service';
import { MapSettings, SettingInfo } from '@app/modules/location/models/settings.model';

@Injectable()
export class SearchFiltersEffects {
  constructor(
    private actions$: Actions<SearchFiltersActions.SearchFiltersActionsUnion>,
    // private apiService: CoreCompanyApiService,
    private divisionCache: DivisionCacheService,
    private store: Store<FiltersState>,
    private settingsService: SettingsApiService
  ) {}

  getCompanies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchFiltersActions.SearchFiltersActionTypes.GET_COMPANIES),
      concatLatestFrom(() => this.store.select(selectAllPermissions)),
      concatMap(([action, allPermissions]) => {
        const { isZonarUser, companies } = allPermissions;
        // if (!isZonarUser) {
        const formattedCompanies = companies
          .map(c => c as unknown as Company)
          .map(c => ({ title: c.name, value: c.id, anonymizedData: c.anonymizedData }));
        this.store.dispatch(SearchFiltersActions.saveCompanies({ companies: formattedCompanies }));
        return of(SearchFiltersActions.getCompaniesSuccess());
        // }

        // this.store.dispatch(
        //   SearchFiltersActions.saveCompanies({
        //     companies: companies.map(c => ({ title: c.name, value: c.id, anonymizedData: c.anonymizedData }))
        //   })
        // );
        // return SearchFiltersActions.getCompaniesSuccess();

        //   return this.apiService.getCompanies(action.params).pipe(
        //     tap(result => {
        //       this.store.dispatch(
        //         SearchFiltersActions.saveCompanies({
        //           companies: result.body.map(c => ({ title: c.name, value: c.id, anonymizedData: c.anonymizedData }))
        //         })
        //       );
        //     }),
        //     map(result => {
        //       const pageCount = result.headers.get('x-page-count');
        //       if (action.params.page < pageCount) {
        //         const newParams = { ...action.params, page: action.params.page + 1 };
        //         return SearchFiltersActions.getCompanies({ params: newParams });
        //       } else {
        //         return SearchFiltersActions.getCompaniesSuccess();
        //       }
        //     })
        //   );
      }),
      catchError(error => {
        return of(SearchFiltersActions.getCompaniesFailure({ error }));
      })
    )
  );

  getDivisions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SearchFiltersActions.SearchFiltersActionTypes.GET_DIVISIONS),
      concatLatestFrom(() => this.store.select(fromPermissions.selectAllPermissions)),
      concatMap(([action, permissions]) => {
        const { params } = action;
        let { companyId } = action;
        const { isZonarUser, divisions } = permissions;

        // somewhere upstream, comapnyId is coming back an as object of { companyId: "some string"...} and that was too difficult to debug for the scope of ZTT-43, hence this check. This was also the source of why a multi-company user did not work in staging, but worked well ind ev
        companyId = typeof companyId === 'string' ? companyId : (companyId as any).id;

        //if (!isZonarUser) {
        const formattedDivisions = divisions.map(d => d as unknown as Division).filter(d => d.companyId === companyId);
        return of(SearchFiltersActions.getSearchFiltersDivisionsSuccess({ divisions: formattedDivisions }));
        //}

        // const newParams = {
        //   ...params,
        //   status: 'ACTIVE',
        //   type: 'LEGACY',
        //   per_page: env.apiRequestPageSize
        // };

        // return this.apiService.getCompanyDivisions(companyId, newParams).pipe(
        //   map(result => {
        //     this.divisionCache.divisions = result;
        //     return SearchFiltersActions.getSearchFiltersDivisionsSuccess({ divisions: result });
        //   })
        // );
      }),
      catchError(error => {
        return of(SearchFiltersActions.getSearchFiltersDivisionsFailure({ error }));
      })
    );
  });

  // getLocations$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(SearchFiltersActions.getSearchFiltersLocations),
  //     concatLatestFrom(() => this.store.select(selectAllPermissions)),
  //     concatMap(([action, allPermissions]) => {
  //       const { companyId, legacyAccountCode, params } = action;
  //       const { isZonarUser, locations } = allPermissions;
  //       if (!isZonarUser) {
  //         const locationOptions = locations.filter(l => l.legacyAccountCode === legacyAccountCode);
  //         this.store.dispatch(SearchFiltersActions.saveSearchFiltersLocations({ locations: locationOptions }));
  //         return of(SearchFiltersActions.getSearchFiltersLocationsSuccess());
  //       }
  //       const newParams = {
  //         ...params,
  //         status: 'ACTIVE',
  //         type: 'LEGACY_LOCATION',
  //         legacyAccountCode,
  //         page: 1,
  //         per_page: env.apiRequestPageSize
  //       };

  //       return this.apiService.getCompanyDivisions(companyId, newParams).pipe(
  //         tap(result => {
  //           this.store.dispatch(
  //             SearchFiltersActions.saveSearchFiltersLocations({
  //               locations: result
  //             })
  //           );
  //         }),
  //         map(_ => {
  //           return SearchFiltersActions.getSearchFiltersLocationsSuccess();
  //         })
  //       );
  //     }),
  //     catchError(error => {
  //       return of(SearchFiltersActions.getSearchFiltersLocationsFailure({ error }));
  //     })
  //   )
  // );

  getCompaniesOnSaveEntities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionsActionTypes.SAVE_ENTITIES),
      switchMap(action => {
        const { companies } = action;
        if ((companies as string[]).length) {
          return of(SearchFiltersActions.getCompanies({ params: { q: `id:${companies[0]}` } }));
        }
        return of(SearchFiltersActions.getCompanies({ params: { page: 1, per_page: env.apiRequestPageSize } }));
      })
    )
  );

  getDivisionsOnSaveEntities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionsActionTypes.SAVE_ENTITIES),
      filter(action => {
        const { companies } = action;
        return !!companies[0]; // true (continue) if companies[0] is defined (a customer)
      }),
      switchMap(action => {
        const { companies, divisions } = action;
        const companyId = companies[0] as string;
        const params = (divisions as string[]).length > 0 ? { divisionIds: divisions } : {};
        if ((divisions as string[]).length) {
          return of(
            SearchFiltersActions.getSearchFiltersDivisions({
              companyId,
              params: { divisionIds: divisions }
            })
          );
        }
        return of(SearchFiltersActions.getSearchFiltersDivisions({ companyId }));
      })
    )
  );

  // getLocationsOnLoadCompaniesAndDivisionsSuccess$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(
  //         SearchFiltersActions.SearchFiltersActionTypes.GET_DIVISIONS_SUCCESS,
  //         SearchFiltersActions.SearchFiltersActionTypes.GET_COMPANIES_SUCCESS
  //       ),
  //       concatMap(action =>
  //         of(action).pipe(
  //           concatLatestFrom(() => [
  //             this.store.pipe(select(fromFilters.selectAllFilters)),
  //             this.store.pipe(select(fromSearchFilters.selectCompaniesLoadingState)),
  //             this.store.pipe(select(fromSearchFilters.selectDivisionsLoadingState))
  //           ])
  //         )
  //       ),
  //       filter(([action, filters, companiesLoaded, divisionsLoaded]) => {
  //         return (
  //           companiesLoaded === ResourceLoadState.LOAD_SUCCESSFUL &&
  //           divisionsLoaded === ResourceLoadState.LOAD_SUCCESSFUL
  //         );
  //       }),
  //       map(([action, filters, companiesLoaded, divisionsLoaded]) => {
  //         const companyId = filters.companies[0].value;
  //         const division = filters.divisions.find(d => d.companyId === companyId);
  //         const legacyAccountCode = division?.legacyAccountCode;
  //         const params = { page: 1, per_page: env.apiRequestPageSize };
  //         this.store.dispatch(SearchFiltersActions.getSearchFiltersLocations({ companyId, legacyAccountCode, params }));
  //       })
  //     ),
  //   { dispatch: false }
  // );

  setDefaultFilterOnEntitiesLoadSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          SearchFiltersActions.SearchFiltersActionTypes.GET_COMPANIES_SUCCESS,
          SearchFiltersActions.SearchFiltersActionTypes.GET_DIVISIONS_SUCCESS
          //  SearchFiltersActions.SearchFiltersActionTypes.GET_LOCATIONS_SUCCESS
        ),
        concatMap(action =>
          of(action).pipe(
            concatLatestFrom(() => [
              this.store.pipe(select(fromSearchFilters.selectCompaniesLoadingState)),
              this.store.pipe(select(fromSearchFilters.selectDivisionsLoadingState)),
              // this.store.pipe(select(fromSearchFilters.selectLocationsLoadingState)),
              this.store.pipe(select(fromPermissions.selectAllPermissions)),
              this.store.pipe(select(fromFilters.selectDefaultFilter)),
              this.store.pipe(select(RouterSelectors.selectQueryParams)),
              this.settingsService.userSettingsCache$
            ])
          )
        ),
        filter(
          ([
            action,
            companiesLoaded,
            divisionsLoaded,
            // locationsLoaded,
            permissions,
            filters,
            queryParams,
            settingsCache
          ]) => {
            const entitiesLoaded =
              companiesLoaded === ResourceLoadState.LOAD_SUCCESSFUL &&
              divisionsLoaded === ResourceLoadState.LOAD_SUCCESSFUL;
            // locationsLoaded === ResourceLoadState.LOAD_SUCCESSFUL;
            return entitiesLoaded;
          }
        ),
        map(
          ([
            action,
            companiesLoaded,
            divisionsLoaded,
            // locationsLoaded,
            permissions,
            defaultFilter,
            queryParams,
            settingsCache
          ]) => {
            let powerOn = defaultFilter.powerOn;
            let siteGroup = defaultFilter.siteGroup;
            const settingsMap = settingsCache as Map<string, SettingInfo>;

            if (
              queryParams?.powerOn &&
              typeof queryParams.powerOn === 'string' &&
              ['true', 'false'].includes(queryParams.powerOn.toLowerCase())
            ) {
              powerOn = queryParams.powerOn === 'true' ? true : false;
            }

            if (
              queryParams?.siteGroup &&
              typeof queryParams.siteGroup === 'string' &&
              ['true', 'false'].includes(queryParams.siteGroup.toLowerCase())
            ) {
              siteGroup = queryParams.siteGroup === 'true' ? true : false;
            }

            let sortOrder = defaultFilter.sortOrder;
            let sortAttribute = defaultFilter.sortAttribute;
            if (settingsMap.has(MapSettings.MAP_SORT_ORDER)) {
              const sortSetting = settingsMap.get(MapSettings.MAP_SORT_ORDER).value;
              const sortParams = this.mapSettingToSortParams(sortSetting);
              sortOrder = sortParams.sortOrder;
              sortAttribute = sortParams.sortAttribute;
            }

            if (queryParams?.sortOrder && ['asc', 'desc'].includes(queryParams.sortOrder.toLowerCase())) {
              sortOrder = queryParams.sortOrder;
            }

            if (
              queryParams?.sortAttribute &&
              ['assetName', 'geoEventTs', 'driverName'].includes(queryParams.sortAttribute)
            ) {
              sortAttribute = queryParams.sortAttribute;
            }

            let search = defaultFilter.search;
            if (queryParams?.search) {
              search = queryParams.search;
            }

            let searchTerms = [...defaultFilter.searchTerms];
            if (queryParams?.searchTerms) {
              if (Array.isArray(queryParams.searchTerms)) {
                searchTerms = [...queryParams.searchTerms];
              } else {
                searchTerms = [queryParams.searchTerms];
              }
            }

            const company = queryParams?.company ? queryParams.company : defaultFilter?.company?.id;

            let divisions = [];
            // queryParams divisions could be a string or an array of strings
            if (queryParams?.divisions) {
              if (Array.isArray(queryParams.divisions)) {
                divisions = [...queryParams.divisions];
              } else {
                divisions = [queryParams.divisions];
              }
              // TODO: what's up with this permissions stuff?
              // TODO: how do we handle the case where the query param divisions don't line up w/ permissions?
            } else if (permissions.divisions.length) {
              divisions = [...permissions.divisions];
            }

            // queryParams locations could be a string or an array of strings
            // let locations = defaultFilter.locations;
            // if (queryParams?.locations) {
            //   if (Array.isArray(queryParams.locations)) {
            //     locations = [...queryParams.locations];
            //   } else {
            //     locations = [queryParams.locations];
            //   }
            // }

            // if we want to support deep linking to an asset list filtered by driver, will need to add logic here
            // to get the driver id from query params
            // and change FilterDialogState from current (hack) of having driver be an EntityResource
            // better implementation would be to have driver be the driver ID, the same as for example, company is company ID
            const driver = defaultFilter.driver;

            const filterArgs = {
              powerOn,
              sortOrder,
              sortAttribute,
              search,
              company,
              divisions,
              //locations,
              driver,
              searchTerms,
              siteGroup
            };

            // filters.filter.locations still not up-to-date in setDefaultFilter
            this.store.dispatch(FilterActions.setDefaultFilter({ filterArgs }));
          }
        )
      ),
    { dispatch: false }
  );

  // getLocationsForLimitedUser$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(SearchFiltersActions.SearchFiltersActionTypes.GET_LOCATIONS_FOR_LIMITED_USER),
  //     concatLatestFrom(() => [
  //       this.store.select(fromFilters.selectAllFilters),
  //       this.store.select(selectAllPermissions)
  //     ]),
  //     switchMap(([action, filters, allPermissions]) => {
  //       // if state already has locations, clear it out to prevent concatenation of dup locations
  //       if (filters.locations.length) {
  //         this.store.dispatch(SearchFiltersActions.clearSearchFiltersLocations());
  //       }

  //       const selectedAccountId = action.locations[0];
  //       const selectedAccount = allPermissions.divisions.find(d => (d as any as Division).id === selectedAccountId);
  //       const legacyAccountCode = (selectedAccount as any as Division).legacyAccountCode;

  //       const locationOptions = allPermissions.locations.filter(l => l.legacyAccountCode === legacyAccountCode);

  //       // regardless if locations has a length, we still want to dispatch the locations array. An empty array disables the locations dropdown
  //       this.store.dispatch(SearchFiltersActions.saveSearchFiltersLocations({ locations: locationOptions }));
  //       return of(SearchFiltersActions.getSearchFiltersLocationsSuccess());
  //     })
  //   )
  // );

  setLimitedUserDivisions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SearchFiltersActions.SearchFiltersActionTypes.GET_DIVISIONS_FOR_LIMITED_USER),
      concatLatestFrom(() => this.store.select(selectAllPermissions)),
      switchMap(([action, allPermissions]) => {
        const { companyId, divisions } = action;
        const selectedCompanyId = (companyId as any).id;

        const accountOptions = allPermissions.divisions
          .map(d => d as any)
          .filter(d => {
            return (d as any).companyId === selectedCompanyId;
          });

        return of(SearchFiltersActions.getSearchFiltersDivisionsSuccess({ divisions: accountOptions }));
      })
    );
  });

  mapSettingToSortParams(settingValue: string): { sortAttribute: SortAttribute; sortOrder: SortOrder } {
    switch (settingValue) {
      case 'ASSET_ASC':
        return { sortAttribute: 'assetName', sortOrder: 'asc' };
      case 'ASSET_DESC':
        return { sortAttribute: 'assetName', sortOrder: 'desc' };
      case 'DRIVER_ASC':
        return { sortAttribute: 'driverName', sortOrder: 'asc' };
      case 'DRIVER_DESC':
        return { sortAttribute: 'driverName', sortOrder: 'desc' };
      case 'OLDEST':
        return { sortAttribute: 'geoEventTs', sortOrder: 'asc' };
      case 'NEWEST':
        return { sortAttribute: 'geoEventTs', sortOrder: 'desc' };
    }
  }
}
